import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

// LIVE-DATA-CLEANUP-01 · C5-C1. Read-only client for the existing LDC01 service.
// Visibility is decided ONLY by the server (GET /admin/ldc01/status). No mutating calls here.
export const LDC01_ROUTE = "/admin/maintenance/live-data-cleanup";
export const NP = "Not provided by server";
// C5-C1: execution controls are not authorised. Hard-locked regardless of any gate result.
export const EXECUTION_CONTROLS_AUTHORISED = false;

const errInfo = (e) => ({
  code: e?.response?.status || 0,
  detail: typeof e?.response?.data?.detail === "string" ? e.response.data.detail : (e?.message || "Request failed"),
});

export function useLdc01Access() {
  const { user } = useAuth();
  const isAdmin = (user?.role || "") === "Administrator";
  const [state, setState] = useState({ phase: "loading", status: null, error: null });

  const load = useCallback(async () => {
    if (!isAdmin) { setState({ phase: "denied", status: null, error: { code: 0, detail: "Administrator role required" } }); return; }
    setState((s) => ({ ...s, phase: "loading" }));
    try {
      const { data } = await api.get("/admin/ldc01/status");
      setState({ phase: "ok", status: data, error: null, at: new Date().toISOString() });
    } catch (e) {
      setState({ phase: "denied", status: null, error: errInfo(e) });
    }
  }, [isAdmin]);

  useEffect(() => { load(); }, [load]);
  return { ...state, reload: load };
}

export async function fetchJob(jobId) {
  return getJson(`/admin/ldc01/jobs/${encodeURIComponent(jobId)}/summary`);
}

export async function getJson(path) {
  try {
    const { data } = await api.get(path);
    return { data, job: data, error: null };
  } catch (e) {
    return { data: null, job: null, error: errInfo(e) };
  }
}

// Phase A1 read-only evidence (all GET). Missing/failed responses stay null → UI shows PENDING / NOT VERIFIED.
export async function loadEvidence() {
  const paths = { manifest: "/manifest", approval: "/manifest/approval", evidence: "/evidence", approvals: "/approvals",
    environment: "/environment", coordination: "/coordination" };
  const keys = Object.keys(paths);
  const res = await Promise.all(keys.map((k) => getJson(`/admin/ldc01${paths[k]}`)));
  const out = { errors: {} };
  keys.forEach((k, i) => { out[k] = res[i].data; if (res[i].error) out.errors[k] = res[i].error; });
  return out;
}

export const latestOf = (jobs, kinds) => (jobs || []).find((j) => kinds.includes(j.kind)) || null;
